import React from 'react';
import { DocumentGenerator } from '../DocumentGenerator';
import { DocumentList } from '../DocumentList';
import { useNavigate } from 'react-router-dom';

export function Units() {
  const navigate = useNavigate();

  const handleDocumentCreated = () => {
    const shouldNavigate = window.confirm(
      '¿Te gustaría crear sesiones para esta unidad?'
    );
    if (shouldNavigate) {
      navigate('/sessions');
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Unidades</h1>
        <p className="mt-2 text-gray-600">
          Crea y gestiona unidades de aprendizaje con ayuda de IA
        </p>
      </div>
      
      <DocumentGenerator type="unit" onDocumentCreated={handleDocumentCreated} />
      <DocumentList type="unit" />
    </div>
  );
}